export const hasUtmParams = (url) => {
  if (!url) return false

  try {
    const normalizedUrl = /^https?:\/\//i.test(url) ? url : `https://${url}`

    const params = new URL(normalizedUrl).searchParams

    return ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].some((param) =>
      params.has(param)
    )
  } catch {
    return false
  }
}
